import React from 'react';
import moment from 'moment';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { CookiesProvider } from 'react-cookie';
import { ThroughProvider } from 'react-through';
import { ConnectedRouter } from 'react-router-redux';
import { createBrowserHistory } from 'history';
import { PersistGate } from 'redux-persist/lib/integration/react';

import { DEFAULT_LOCALE } from './constants/locale';

import App from './components/App';
import TrackingProvider from './tracking/provider';
import { configureStore } from './store';

import './scss/index.scss';

const history = createBrowserHistory();

const { store, persistor } = configureStore(history);

// set Momentjs locale
moment.locale(DEFAULT_LOCALE);

render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <ConnectedRouter history={history}>
                <CookiesProvider>
                    <ThroughProvider>
                        <TrackingProvider>
                            <App />
                        </TrackingProvider>
                    </ThroughProvider>
                </CookiesProvider>
            </ConnectedRouter>
        </PersistGate>
    </Provider>,
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js